// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Ib47j","icon":"classes_icon__VsWWf","number":"classes_number__EvMUX"};